import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_TABLE_PARAMS, type EducationClass } from 'shared/api';
import type { EducationsClassFilters } from 'shared/api';
import type { AntdTableParams } from 'shared/types';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { EducationClassesTableState } from './types';
import { educationClassesTableSelectors } from './selectors';

export const initialState: EducationClassesTableState = {
  tableParams: DEFAULT_TABLE_PARAMS,
  tableFilters: {},
};

export const educationClassesSlice = createSlice({
  name: 'educationClasses',
  initialState,
  reducers: {
    setTableParams: (state, action: PayloadAction<AntdTableParams<EducationClass>>) => {
      return {
        ...state,
        tableParams: {
          ...state.tableParams,
          ...action.payload,
        },
      };
    },
    setFilters: (state, action: PayloadAction<EducationsClassFilters>) => {
      state.tableFilters = action.payload;
      state.tableParams.pagination.current = 1;
    },
  },
});

export const { actions: educationClassesTableActions, reducer: educationClassesTableReducer } =
  educationClassesSlice;
export { educationClassesTableSelectors };
